module.exports = __webpack_public_path__ + "static/img/decor2.196fd03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/decor2.png
// module id = K5pY
// module chunks = 0